import { Routes } from '@angular/router';


import { AuthGaurdService } from '@services/auth-guard/auth-gaurd.service';
import { AuthGuard2Service } from '@services/auth-guard2/auth-guard2.service';
import { LoginComponent } from '@app/login/login.component';
import { ForgotComponent } from '@app/forgot/forgot.component';
import { VerificationComponent } from '@app/verification/verification.component';
import { VerificationMessageComponent } from '@app/verification-message/verification-message.component';


export const AppRoutes: Routes = [{
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
}, {
    path: 'login',
    redirectTo: 'login',
    pathMatch: 'full'
}, {
    path: 'verifyAccount/:id',
    redirectTo: 'verifyAccount/:id',
    pathMatch: 'full'
},
{
    path: 'admin',
    loadChildren: './admin/admin.module#AdminModule',
    canActivate: [AuthGaurdService]
},
{
    path: 'supervisor',
    loadChildren: './supervisor/supervisor.module#SupervisorModule',
},
{
        path: 'fieldagent',
        loadChildren: './fieldagent/fieldagent.module#FieldagentModule'
},
{
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard2Service]
},
{
    path: 'verifyAccount/:id',
    component: VerificationMessageComponent
},
{
    path: 'forgot',
    component: ForgotComponent,
    canActivate: [AuthGuard2Service]
},
{
    path: 'verification/:email',
    component: VerificationComponent,
    canActivate: [AuthGuard2Service]
}];



// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/app/app.routes.ts